module.exports = __webpack_public_path__ + "img/autonomy.045ad4a7.png";